import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "vrv_admin_token";
export const LOGO = "/logo.png";
export const PLACEHOLDER = "/samples/3.jpg";

export const api = axios.create({ baseURL: API });
export const adminApi = axios.create({ baseURL: `${API}/admin` });

adminApi.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/admin/login";
    }
    return Promise.reject(e);
  }
);

const fmt = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2 });
export const inr = (v) => (v == null || v === "" ? "" : fmt.format(Number(v)));

export const discount = (p) =>
  p.regular_price && p.regular_price > p.price ? Math.round((1 - p.price / p.regular_price) * 100) : 0;

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || ""}: ${x.msg}`).join(", ");
  return fallback;
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

export const shippingFor = (ship, india, subtotal) => {
  if (!ship) return 0;
  const [rate, free] = india ? [ship.india_rate, ship.india_free] : [ship.intl_rate, ship.intl_free];
  return free && subtotal >= free ? 0 : Number(rate);
};

export async function downloadAdmin(path, filename) {
  const r = await adminApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
